import { json_headers, request } from './common';

export default class PackagesService {
  static basePath(idOffer) {
    return `${window.configs.API_HOST}/api/offers/${idOffer}/bundle-packages`;
  }

  static getPackageSchema(idOffer) {
    return request(this.basePath(idOffer), { method: 'OPTIONS' });
  }

  static createPackage(object, idOffer) {
    const jsonData = JSON.stringify(object);
    return request(this.basePath(idOffer), {
      method: 'POST',
      headers: json_headers,
      body: jsonData,
    });
  }

  static updatePackage(object, idOffer, idPackage) {
    const jsonData = JSON.stringify(object);
    return request(this.basePath(idOffer) + '/' + idPackage, {
      method: 'PATCH',
      headers: json_headers,
      body: jsonData,
    });
  }

  static deletePackage(idOffer, idPackage) {
    return request(this.basePath(idOffer) + '/' + idPackage, {
      method: 'DELETE',
      headers: json_headers,
    });
  }
}
